import { Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import Loading from "../components/Loading";
import EmptyChart from "../components/EmptyChart";
import ChartLayout from "../../../components/ChartLayout";

import PerformanceForm from "./PerformanceForm";
import PerformanceChart from "./PerformanceChart";
import PerformanceResult from "./PerformanceResult";
import DisplayUnitSelector from "../../SpuChart/components/DisplayUnitSelector";
import useDisplayUnits from "../../SpuChart/displayUnits/useDisplayUnits";

import useSpuPoints from "../../../stores/spuPoints";

const Performance = () => {
  const { name, info, dataset, performance, loading } = useSpuPoints();
  const { fieldsValue, fieldsResult } = performance;
  const [searchParams, setSearchParams] = useSearchParams();
  const { displayUnits, updateDisplayUnit, setParamsWithDisplayUnits } = useDisplayUnits(searchParams, setSearchParams);

  if (loading) {
    return <Loading />;
  }

  if (!name || !dataset) {
    return <EmptyChart />;
  }

  return (
    <ChartLayout
      chart={
        <PerformanceChart
          key={name}
          name={name}
          info={info}
          dataset={dataset}
          performance={fieldsValue}
          displayUnits={displayUnits}
          setParamsWithDisplayUnits={setParamsWithDisplayUnits}
        />
      }
      form={
        <Fragment>
          <DisplayUnitSelector displayUnits={displayUnits} onChange={updateDisplayUnit} />
          <PerformanceForm
            displayUnits={displayUnits}
            setParamsWithDisplayUnits={setParamsWithDisplayUnits}
          />
        </Fragment>
      }
      result={
        <PerformanceResult
          fieldsResult={fieldsResult}
          displayUnits={displayUnits}
        />
      }
    />
  );
};

export default Performance;
